import { render, staticRenderFns } from "./ModalInibirRestricoes.vue?vue&type=template&id=25b0efd4&lang=pug"
import script from "./ModalInibirRestricoes.vue?vue&type=script&lang=js"
export * from "./ModalInibirRestricoes.vue?vue&type=script&lang=js"
import style0 from "./ModalInibirRestricoes.vue?vue&type=style&index=0&id=25b0efd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports